import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useApiStore from '../apiStore/useApiStore';
import { thirdPartyStore } from './thirdPartyStore';

const useThirdPartyStore = createStore({
  creator: thirdPartyStore({
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'thirdParty',
  middlewares: {
    devtools: true,
  },
});

export default useThirdPartyStore;
